import { Pipe, PipeTransform } from '@angular/core';
import { ClientDocumentRelation } from '../../model/client-document-relation.model';
import { TxDocument } from '../../model/document.model';

@Pipe({
  name: 'checkClientRelationToDoc',
})
export class CheckClientRelationToDocPipe implements PipeTransform {
  transform(document: TxDocument, clientId: string, relation: ClientDocumentRelation): boolean {
    return document.getSignerById(clientId)?.relation === relation;
  }
}
